import { useNavigate } from 'react-router-dom';
import { NavigateFunction } from 'react-router/dist/lib/hooks';
import { useContext } from 'react';
import { CalculatorPrefixContext } from '../contexts/CalculatorContext';

export function useCalculatorNavigate(params = {disablePrefix: false}): NavigateFunction {
    const navigate = useNavigate()
    const calculatorPrefixContext = useContext(CalculatorPrefixContext)!;
    const calculatorPrefix = !params.disablePrefix ? `/${calculatorPrefixContext[0]}` : ''

    return (route) => {

        return navigate(`${calculatorPrefix}/${route}`);
    }
}
